/* eslint-disable */

(function ($) {
    $.widget('ep.separator_record_field', $.ep.base_record_field, {
        options: {
            templateId: 'separator-record-field'
        }
    });
})(jQuery);

/* eslint-enable */